module.exports = __webpack_public_path__ + "media/src/images/icons/reward/medal-dbd7c146130b5699322fc8adeed2cf12.svg";